import usercontroller from './user';
import cookie from '../helpers/cookie';
import url from '../helpers/url';
import config from '../core/config';

let HandleGooglePurchase = response => {
  return new Promise((resolve, reject) => {
    let authentication = {};
    usercontroller.manageSocialNetwork(
      response.userData.id,
      response.userData.idToken,
      response.userData.givenName,
      response.userData.familyName,
      response.userData.email
    ).then((data) => {
      let auth = data.response.split('|');

      authentication = {
        'X-Token': auth[1],
        'X-Value': auth[2]
      };

      return usercontroller.saveGoogleUserPurchase(
        response,
        authentication
      );
    }).then((data) => {
      return usercontroller.requestUserMe(authentication);
    }).then((data) => {
      return usercontroller.getUserAnalyticsSubscription(cookie.read('UsuarioId'), authentication);
    }).then(() => {
      resolve();
    }).catch((error) => {
      console.log('Subscribe response error: ', error);
      reject(error);
    });
  });
}

let askLoginPromise = (token) => {
  return new Promise((resolve, reject) => {
    let authentication = {};
    usercontroller.tokenLogin(token)
      .then((data) => {
        let auth = data.response.split('|');

        authentication = {
          'X-Token': auth[1],
          'X-Value': auth[2]
        };
        return usercontroller.requestUserMe(authentication);
      }).then((data) => {
        return usercontroller.getUserAnalyticsSubscription(cookie.read('UsuarioId'), authentication);
      }).then(() => {
        resolve();
      }).catch((error) => {
        console.log('Subscribe response error: ', error);
        reject(error);
      });
  });
}

export default class GoogleManager {

  start(callback) {
    let self = this;
    (window.SWG = window.SWG || []).push(function (subscriptions) {
      self.init(subscriptions)
      callback && callback();
    });
  }

  init(subscriptions) {
    if (this.subscriptions)
      return;

    this.subscriptions = subscriptions;
    this.subscriptions.init('lanacion.com.ar:acceso_digital');
    this.subscriptions.setOnSubscribeResponse(this.subscribeResponse_.bind(this));
    this.subscriptions.setOnEntitlementsResponse(this.setOnEntitlementsResponse_.bind(this));

    this.entitlements = null;

    if (!usercontroller.isLogedIn() && usercontroller.isSWGLoginEnable())
      this.subscriptions.getEntitlements();
  }

  drawButton(containerClass, sku) {
    if (!this || !this.subscriptions)
      throw 'SWG is not initialized';
    let currentSubscriptions = this.subscriptions;
    let containers = document.getElementsByClassName(containerClass);
    for (let i = 0; i < containers.length; i++) {
      let container = containers[i];
      let skuBtn = container.dataset.sku || sku;
      if (!skuBtn)
        continue;

      container.appendChild(currentSubscriptions.createButton(function () {
        currentSubscriptions.subscribe(skuBtn);
      }));
    }
  }

  subscribeResponse_(promise) {
    promise.then(response => {
      let suscribeResponse = response;
      Promise.all([HandleGooglePurchase(suscribeResponse)]).then(() => {
        suscribeResponse.complete()
          .then(() => {
            console.log('subscription has been confirmed');
            // Open the content.
            let callbackurl = url.getUrlParameter(window.location.href, 'callback');
            if (callbackurl) {
              url.redirectTo(atob(callbackurl));
            } else {
              if (window.location.href.toLowerCase().indexOf("suscribirme") > 0) {
                url.redirectTo(config.lnUrl);
              }
            }
          })
      })
        .catch(err => {
          console.log('subscription response failed: ', err);
        });
    }).catch(err => {
      console.log('subscription response failed: ', err);
    });
  }

  setOnEntitlementsResponse_(entitlementsPromise) {
    let currentSubscriptions = this.subscriptions;
    entitlementsPromise.then((function (entitlements) {

      if (usercontroller.isLogedIn())
        return;

      if (!usercontroller.isSWGLoginEnable())
        return;

      if (!entitlements.enablesThis()) {
        return;
      }

      // Entitlements grant access to the product linked to this content.
      // Look up the user. Resolve the promise with an account (if it was found).
      let source = entitlements.entitlements[0].source;
      let token = source === 'google' ? JSON.parse(entitlements.entitlements[0].subscriptionToken).purchaseToken : entitlements.entitlements[0].subscriptionToken;

      const accountPromise = usercontroller.checkIfUserExists(source, token);

      // Notify the user that their account is being looked up. It will resolve
      // when accountPromise resolves.
      currentSubscriptions.waitForSubscriptionLookup(accountPromise).then(account => {
        console.log("Account", account);
        if (account && account.code === "0000") {
          // Account was found.
          // Option 2 - prompt the user to sign in.
          currentSubscriptions.showLoginPrompt().then(() => {
            // User clicked 'Yes'.
            // Notify the user that they're being logged in with Google.   
            Promise.all([askLoginPromise(account.response), currentSubscriptions.showLoginNotification()]).then(() => {
              let callbackurl = url.getUrlParameter(window.location.href, 'callback');
              if (callbackurl) {
                url.redirectTo(atob(callbackurl));
              } else {
                if (window.location.href.toLowerCase().indexOf("suscribirme") > 0) {
                  url.redirectTo(config.lnUrl)
                } else {
                  url.reload();
                }
              }
            })
              .catch(err => {
                console.log(err);
              });
          }, reason => {
            // User clicked 'No'. Publisher can decide how to handle this situation.
            usercontroller.forceSWGLogout();
          });
          // Remove the "Subscribed with... Manage" bottom toast.
          entitlements.ack();
        } else if (account && account.code === "0002") { //USUARIO NO EXISTE
          // Account was not found. Let's create a new one.
          currentSubscriptions.completeDeferredAccountCreation({
            entitlements: entitlements,
            consent: true
          }).then((response) => {
            // 1. The user has consented to account creation. Create account
            // based on the response.                                                             
            HandleGooglePurchase(response).then(() => {
              response.complete().then(() => {
                // 3. The flow is complete.
                // Remove the "Subscribed with... Manage" bottom toast.
                entitlements.ack();
                let callbackurl = url.getUrlParameter(window.location.href, 'callback');

                if (callbackurl) {
                  url.redirectTo(atob(callbackurl));
                } else {
                  if (window.location.href.toLowerCase().indexOf("suscribirme") > 0) {
                    url.redirectTo(config.lnUrl)
                  }
                }
              });
            })
              .catch(err => {
                console.log("setOnEntitlementsResponse_.HandleGooglePurchase Error", err);
              });
          })
            .catch(err => {
              console.log("setOnEntitlementsResponse_ The user hasn't consented the account creation");
            });
        }
      });
    }).bind(this), function (reason) {
      console.log('entitlements failed: ', reason);
    });
  }
}


// WEBPACK FOOTER //
// ./~/@ln/registracionlibs/src/controllers/swg.js